import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

const AuthCallback = () => {
  const history = useHistory();
  const { search } = useLocation();

  useEffect(() => {
    // Get token from URL
    const params = new URLSearchParams(search);
    console.log("TEST: url params:", params);
    const token = params.get("access_token");

    if (token) {
      // Store the token
      localStorage.setItem("auth_token", token);

      // Get the stored redirect path or default to home
      const redirectPath = localStorage.getItem("redirectPath") || "/";
      localStorage.removeItem("redirectPath"); // Clean up

      // Redirect to the app
      history.push(redirectPath);
      // navigate(redirectPath);
    } else {
      // Handle error case
      history.push("/");
    }
  }, [history]);

  return <div>Loading...</div>; // Show while processing
};

export default AuthCallback;
